import { formatHolidayDate } from '../../calendario/utils/laborCalendarUtils';
import { getEmployeeDisplayName } from '../../calendario/utils/laborFactoryUtils';

export const ABSENCE_TYPES = {
  vacation: {
    label: 'Vacaciones',
    className: 'bg-blue-900/50 text-blue-300 border border-blue-700',
  },
  sick_leave: {
    label: 'Baja médica',
    className: 'bg-red-900/50 text-red-300 border border-red-700',
  },
  maternity: {
    label: 'Maternidad / paternidad',
    className: 'bg-purple-900/50 text-purple-300 border border-purple-700',
  },
  training: {
    label: 'Formación',
    className: 'bg-cyan-900/50 text-cyan-300 border border-cyan-700',
  },
  special_leave: {
    label: 'Permiso especial',
    className: 'bg-amber-900/50 text-amber-300 border border-amber-700',
  },
  unpaid_leave: {
    label: 'Excedencia',
    className: 'bg-gray-700 text-gray-300 border border-gray-600',
  },
};

export const ABSENCE_TYPE_OPTIONS = Object.entries(ABSENCE_TYPES).map(([value, cfg]) => ({
  value,
  label: cfg.label,
}));

export const ABSENCE_STATUSES = {
  pending: {
    label: 'Pendiente',
    className: 'bg-amber-900/50 text-amber-300 border border-amber-700',
  },
  approved: {
    label: 'Aprobada',
    className: 'bg-emerald-900/50 text-emerald-300 border border-emerald-700',
  },
  rejected: {
    label: 'Rechazada',
    className: 'bg-red-900/50 text-red-300 border border-red-700',
  },
  cancelled: {
    label: 'Cancelada',
    className: 'bg-gray-700 text-gray-400 border border-gray-600',
  },
};

export const ABSENCE_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Todos los estados' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'approved', label: 'Aprobada' },
  { value: 'rejected', label: 'Rechazada' },
  { value: 'cancelled', label: 'Cancelada' },
];

export function getAbsenceTypeLabel(type) {
  return ABSENCE_TYPES[type]?.label || type || '—';
}

export function getAbsenceStatusLabel(status) {
  return ABSENCE_STATUSES[status]?.label || status || '—';
}

export function formatAbsenceDate(dateValue) {
  const iso = formatHolidayDate(dateValue);
  if (!iso || iso === '—') return '—';
  try {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('es-ES');
  } catch {
    return iso;
  }
}

export function countAbsenceDays(startDate, endDate) {
  const startStr = formatHolidayDate(startDate);
  const endStr = formatHolidayDate(endDate);
  if (!startStr || !endStr || startStr === '—' || endStr === '—') return 0;
  const [sy, sm, sd] = startStr.split('-').map(Number);
  const [ey, em, ed] = endStr.split('-').map(Number);
  const start = Date.UTC(sy, sm - 1, sd);
  const end = Date.UTC(ey, em - 1, ed);
  if (end < start) return 0;
  return Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
}

export function getAbsenceEmployeeName(absence, employeeNameById = {}) {
  if (absence?.employee) {
    return getEmployeeDisplayName(absence.employee);
  }
  if (absence?.employee_id && employeeNameById[absence.employee_id]) {
    return employeeNameById[absence.employee_id];
  }
  return absence?.employee_id ? `Empleado #${absence.employee_id}` : '—';
}

export function yearDateRange(year) {
  return {
    from: `${year}-01-01`,
    to: `${year}-12-31`,
  };
}
